import React, { useEffect, useMemo, useState } from 'react';
import { BsFolderCheck } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import LoadingSpinner from '../../../components/Spinner';
import { Tab, Tabs } from '../../../components/TabMenu';
import { CypressIds } from '../../../constants/cypressIds';
import { getTabSelectOptions } from '../../../constants/tabMenuTypes';
import { globalRequirementTemplateBuilder } from '../../../redux/reducer';
import { templateFolderOptions } from '../util/options';

import PublishedTemplatesListPanel from './panels/PublishedTemplatesListPanel';

const RequirementsTemplates = () => {
  const dispatch = useDispatch();
  const defaultFolders = getTabSelectOptions('templateFolderMenuTabs');
  const createButton = defaultFolders.find(tab => tab.tabId === 'create_new');
  const defaultFolderTabs = defaultFolders.filter(tab => tab.tabId !== 'create_new');
  const [currentPage, setCurrentPage] = useState(1);
  const { activeTab } = useParams();

  const { data, lastPage, total } = useSelector(globalRequirementTemplateBuilder.selectRequirementTemplateFolders);

  const companyTemplateFolderTabs = useMemo(() => data && data.map(({ id, name, requirementTemplatesCount }) => ({
    id,
    cypressId: CypressIds.reqTemplatesFolderTabByName(name),
    tabId: id.toString(),
    title: name,
    description: requirementTemplatesCount === 1 ? '1 Template' : `${requirementTemplatesCount} Templates`,
    icon: BsFolderCheck,
    main: PublishedTemplatesListPanel,
    header: () => null,
    subMenu: templateFolderOptions,
    onTabSelect: () => {
      dispatch(globalRequirementTemplateBuilder.setCurrentRequirementTemplateFolder(id));
      dispatch(globalRequirementTemplateBuilder.setCurrentRequirementTemplateStatusFilters({ published: true }));
    }
  })), [data]);

  const tabFolders = [createButton, ...companyTemplateFolderTabs, ...defaultFolderTabs];

  useEffect(() => {
    if (companyTemplateFolderTabs.length) {
      if (!activeTab) {
        dispatch(globalRequirementTemplateBuilder.setCurrentRequirementTemplateFolder(tabFolders[1].id));
      } else {
        const folder = (activeTab === 'drafts' || activeTab === 'archive') ? '' : Number(activeTab);
        dispatch(globalRequirementTemplateBuilder.setCurrentRequirementTemplateFolder(folder));
      }
    }
  }, [companyTemplateFolderTabs, dispatch]);

  const fetchNextData = () => {
    if (currentPage < lastPage) {
      const pageData = {
        pageNumber: (currentPage + 1),
        pageSize: 25
      };

      setCurrentPage(currentPage + 1);

      dispatch(globalRequirementTemplateBuilder.listRequirementTemplateFolders(pageData));
    }
  };

  if (!companyTemplateFolderTabs.length && total !== 0) {
    return <LoadingSpinner />;
  }

  return (
    <Tabs
      fetchNext={fetchNextData}
      hasMore={companyTemplateFolderTabs.length < total}
      height={companyTemplateFolderTabs.length > 7 ? '645px' : 'auto'}
    >
      {tabFolders.map(option => (
        <Tab
          {...option}
          key={option.tabId}
        />
      ))}
    </Tabs>
  );
};

export default RequirementsTemplates;
